import useFavurTranslation from 'hooks/useFavurTranslation'
import { getMainAndHiddenButtons } from 'redesign/components/templates/task-details-action-buttons/utils/get-main-and-hidden-buttons'
import type { UseActionButtonsProps } from '../types'
import { getNewAbsenceActionButtons } from '../utils/get-new-absence-action-buttons'

export const useActionButtons = (props: UseActionButtonsProps) => {
  const { t } = useFavurTranslation()

  const buttons = getNewAbsenceActionButtons({
    t,
    ...props,
  })

  return getMainAndHiddenButtons(buttons)
}
